import { combineReducers } from "redux";

import {
  BOOKING_GET_LOADING,
  BOOKING_GET_ERROR,
  BOOKING_GET_SUCCESS,
  BOOKING_VIEW_ERROR,
  BOOKING_VIEW_LOADING,
  BOOKING_VIEW_SUCCESS,
  BOOKING_ADD_ERROR,
  BOOKING_ADD_LOADING,
  BOOKING_ADD_SUCCESS,
  BOOKING_HAS_DO_VIEW_ERROR,
  BOOKING_HAS_DO_VIEW_LOADING,
  BOOKING_HAS_DO_VIEW_SUCCESS,
  BOOKING_HAS_DO_UPDATE_ERROR,
  BOOKING_HAS_DO_UPDATE_LOADING,
  BOOKING_HAS_DO_UPDATE_INVALID,
  BOOKING_HAS_DO_UPDATE_SUCCESS,
  BOOKING_LIST_ERROR,
  BOOKING_LIST_LOADING,
  BOOKING_LIST_SUCCESS,
  STATUS_SISA_KUOTA,
  LIST_PAY_SUCCESS,
  PAY_CHANEL_SUCCESS,
  BOOKING_REFUND,
  BOOKING_UPLOAD_EXTERNAL_PO_SUCCESS,
  BOOKING_UPLOAD_EXTERNAL_PO_ERROR,
  BOOKING_UPLOAD_EXTERNAL_PO_LOADING,
  BOOKING_SAVE_EXTERNAL_PO_ERROR,
  BOOKING_SAVE_EXTERNAL_PO_LOADING,
  BOOKING_SAVE_EXTERNAL_PO_SUCCESS,
  BOOKING_VIEW_SUCCESS_OLD,
  BOOKING_VIEW_LOADING_OLD,
  BOOKING_VIEW_ERROR_OLD,
  BOOKING_VIEW_SUCCESS_NEW,
  BOOKING_VIEW_LOADING_NEW,
  BOOKING_VIEW_ERROR_NEW,
  BOOKING_UPDATE_BHP_PO_SUCCESS,
  BOOKING_UPDATE_BHP_PO_ERROR,
  BOOKING_UPDATE_BHP_PO_LOADING,
  GET_DATA_EXCEL_ERROR,
  GET_DATA_EXCEL_LOADING,
  GET_DATA_EXCEL_SUCCESS,
  CHECK_BOOKING_STATUS_SUCCESS,
  CHECK_BOOKING_STATUS_ERROR,
  CHECK_BOOKING_STATUS_LOADING,
  BOOKING_UPLOAD_PEMBAYARAN_JPT_SUCCESS,
  BOOKING_UPLOAD_PEMBAYARAN_JPT_ERROR,
  BOOKING_UPLOAD_PEMBAYARAN_JPT_LOADING,
  BOOKING_UPLOAD_RECIPIENT_GOODS_SUCCESS,
  BOOKING_UPLOAD_RECIPIENT_GOODS_ERROR,
  BOOKING_UPLOAD_RECIPIENT_GOODS_LOADING,
  EDIT_PAYMENT_UPLOAD_SUCCESS,
  EDIT_PAYMENT_UPLOAD_ERROR,
  EDIT_PAYMENT_UPLOAD_LOADING,
} from "actions/constant";

import {
  BOOKING_GET_PREV_ONE_SUCCESS,
  BOOKING_UPDATE_STAT_REDC_SUCCESS,
  EDIT_STATUS_BOOKING_LOADING,
  EDIT_STATUS_BOOKING_SUCCESS,
  EDIT_STATUS_BOOKING_ERROR,
  HANDLE_EXPIRED_CONTAINER_LOADING,
  HANDLE_EXPIRED_CONTAINER_SUCCESS,
  HANDLE_EXPIRED_CONTAINER_ERROR,
} from "actions/bookingAction";

const listPay = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case LIST_PAY_SUCCESS:
      return { isLoad: action.isLoad, val: action.val };
    default:
      return state;
  }
};

const BookingStatUpdate = (
  state = { isLoad: false, val: [], success: false, err: false, errMsg: "" },
  action
) => {
  switch (action.type) {
    case BOOKING_UPDATE_STAT_REDC_SUCCESS:
      return {
        isLoad: action.Loading,
        val: action.data,
        success: action.success,
        err: action.error,
        errMsg: action.errMsg,
      };
    default:
      return state;
  }
};

const BookingPrev = (
  state = { isLoad: false, val: [], success: false, err: false, errMsg: "" },
  action
) => {
  switch (action.type) {
    case BOOKING_GET_PREV_ONE_SUCCESS:
      return {
        isLoad: action.Loading,
        val: action.data,
        success: action.success,
        err: action.error,
        errMsg: action.errMsg,
      };
    default:
      return state;
  }
};

const bookingGetRefund = (state = false, action) => {
  switch (action.type) {
    case BOOKING_REFUND:
      return action.bookingGetRef;
    default:
      return state;
  }
};

const sisaKuotaKontainer = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case STATUS_SISA_KUOTA:
      return { isLoad: action.isLoad, val: action.val };
    default:
      return state;
  }
};

const pay_chanel_generate = (state = false, action) => {
  switch (action.type) {
    case PAY_CHANEL_SUCCESS:
      return action.isLoad;
    default:
      return state;
  }
};

const bookingGetError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_GET_ERROR:
      return action.bookingGetError;
    default:
      return state;
  }
};

const bookingGetLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_GET_LOADING:
      return action.bookingGetLoading;
    default:
      return state;
  }
};

const bookingGetSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_GET_SUCCESS:
      return action.bookingGetSuccess;
    default:
      return state;
  }
};

const bookings = (state = [], action) => {
  switch (action.type) {
    case BOOKING_GET_SUCCESS:
      return action.bookings;
    case BOOKING_LIST_SUCCESS:
      return action.bookings;
    // case GET_DATA_EXCEL_SUCCESS:
    //   return action.bookings;
    default:
      return state;
  }
};

const bookingGetExcelError = (state = false, action) => {
  switch (action.type) {
    case GET_DATA_EXCEL_ERROR:
      return action.bookingGetExcelError;
    default:
      return state;
  }
};

const bookingGetExcelLoading = (state = false, action) => {
  switch (action.type) {
    case GET_DATA_EXCEL_LOADING:
      return action.bookingGetExcelLoading;
    default:
      return state;
  }
};

const bookingGetExcelSuccess = (state = false, action) => {
  switch (action.type) {
    case GET_DATA_EXCEL_SUCCESS:
      return action.bookingGetExcelSuccess;
    default:
      return state;
  }
};

const bookingExcel = (state = [], action) => {
  switch (action.type) {
    case GET_DATA_EXCEL_SUCCESS:
      return action.bookingExcel;
    default:
      return state;
  }
};

const bookingViewLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_LOADING:
      return action.bookingViewLoading;
    default:
      return state;
  }
};

const bookingViewError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_ERROR:
      return action.bookingViewError;
    default:
      return state;
  }
};

const bookingViewSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS:
      return action.bookingViewSuccess;
    default:
      return state;
  }
};

const booking = (state = [], action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS:
      return action.booking;
    default:
      return state;
  }
};

const bookingOld = (state = [], action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS_OLD:
      return action.bookingOld;
    default:
      return state;
  }
};

const bookingViewLoadingOld = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_LOADING_OLD:
      return action.bookingViewLoadingOld;
    default:
      return state;
  }
};

const bookingViewErrorOld = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_ERROR_OLD:
      return action.bookingViewErrorOld;
    default:
      return state;
  }
};

const bookingViewSuccessOld = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS_OLD:
      return action.bookingViewSuccessOld;
    default:
      return state;
  }
};

const bookingNew = (state = [], action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS_NEW:
      return action.bookingNew;
    default:
      return state;
  }
};

const bookingViewLoadingNew = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_LOADING_NEW:
      return action.bookingViewLoadingNew;
    default:
      return state;
  }
};

const bookingViewErrorNew = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_ERROR_NEW:
      return action.bookingViewErrorNew;
    default:
      return state;
  }
};

const bookingViewSuccessNew = (state = false, action) => {
  switch (action.type) {
    case BOOKING_VIEW_SUCCESS_NEW:
      return action.bookingViewSuccessNew;
    default:
      return state;
  }
};

const bookingAdded = (state = [], action) => {
  switch (action.type) {
    case BOOKING_ADD_SUCCESS:
      return action.bookingAdded;
    default:
      return state;
  }
};

const bookingAddError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_ADD_ERROR:
      return action.bookingAddError;
    default:
      return state;
  }
};

const bookingAddLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_ADD_LOADING:
      return action.bookingAddLoading;
    default:
      return state;
  }
};

const bookingAddSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_ADD_SUCCESS:
      return action.bookingAddSuccess;
    default:
      return state;
  }
};

const checkBookingStatus = (state = [], action) => {
  switch (action.type) {
    case CHECK_BOOKING_STATUS_SUCCESS:
      return action.checkBookingStatus;
    default:
      return state;
  }
};

const checkBookingStatusError = (state = false, action) => {
  switch (action.type) {
    case CHECK_BOOKING_STATUS_ERROR:
      return action.checkBookingStatusError;
    default:
      return state;
  }
};

const checkBookingStatusLoading = (state = false, action) => {
  switch (action.type) {
    case CHECK_BOOKING_STATUS_LOADING:
      return action.checkBookingStatusLoading;
    default:
      return state;
  }
};

const checkBookingStatusSuccess = (state = false, action) => {
  switch (action.type) {
    case CHECK_BOOKING_STATUS_SUCCESS:
      return action.checkBookingStatusSuccess;
    default:
      return state;
  }
};

const bookingExternalPOUpload = (state = [], action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_EXTERNAL_PO_SUCCESS:
      return action.bookingExternalPOUpload;
    default:
      return state;
  }
};

const bookingExternalPOUploadError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_EXTERNAL_PO_ERROR:
      return action.bookingExternalPOUploadError;
    default:
      return state;
  }
};

const bookingExternalPOUploadLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_EXTERNAL_PO_LOADING:
      return action.bookingExternalPOUploadLoading;
    default:
      return state;
  }
};

const bookingExternalPOUploadSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_EXTERNAL_PO_SUCCESS:
      return action.bookingExternalPOUploadSuccess;
    default:
      return state;
  }
};

const bookingPembayaranJPTUpload = (state = [], action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_PEMBAYARAN_JPT_SUCCESS:
      return action.bookingPembayaranJPTUpload;
    default:
      return state;
  }
};

const bookingPembayaranJPTUploadError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_PEMBAYARAN_JPT_ERROR:
      return action.bookingPembayaranJPTUploadError;
    default:
      return state;
  }
};

const bookingPembayaranJPTUploadLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_PEMBAYARAN_JPT_LOADING:
      return action.bookingPembayaranJPTUploadLoading;
    default:
      return state;
  }
};

const bookingPembayaranJPTUploadSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_PEMBAYARAN_JPT_SUCCESS:
      return action.bookingPembayaranJPTUploadSuccess;
    default:
      return state;
  }
};
const bookingRecipientGoodsUpload = (state = [], action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_RECIPIENT_GOODS_SUCCESS:
      return action.bookingRecipientGoodsUpload;
    default:
      return state;
  }
};

const bookingRecipientGoodsUploadError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_RECIPIENT_GOODS_ERROR:
      return action.bookingRecipientGoodsUploadError;
    default:
      return state;
  }
};

const bookingRecipientGoodsUploadLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_RECIPIENT_GOODS_LOADING:
      return action.bookingRecipientGoodsUploadLoading;
    default:
      return state;
  }
};

const bookingRecipientGoodsUploadSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPLOAD_RECIPIENT_GOODS_SUCCESS:
      return action.bookingRecipientGoodsUploadSuccess;
    default:
      return state;
  }
};

const editPaymentUpload = (state = [], action) => {
  switch (action.type) {
    case EDIT_PAYMENT_UPLOAD_SUCCESS:
      return action.editPaymentUpload;
    default:
      return state;
  }
};

const editPaymentUploadError = (state = false, action) => {
  switch (action.type) {
    case EDIT_PAYMENT_UPLOAD_ERROR:
      return action.editPaymentUploadError;
    default:
      return state;
  }
};

const editPaymentUploadLoading = (state = false, action) => {
  switch (action.type) {
    case EDIT_PAYMENT_UPLOAD_LOADING:
      return action.editPaymentUploadLoading;
    default:
      return state;
  }
};

const editPaymentUploadSuccess = (state = false, action) => {
  switch (action.type) {
    case EDIT_PAYMENT_UPLOAD_SUCCESS:
      return action.editPaymentUploadSuccess;
    default:
      return state;
  }
};

const bookingExternalPOSave = (state = [], action) => {
  switch (action.type) {
    case BOOKING_SAVE_EXTERNAL_PO_SUCCESS:
      return action.bookingSaveExternalPO;
    default:
      return state;
  }
};

const bookingSaveExternalPOError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_SAVE_EXTERNAL_PO_ERROR:
      return action.bookingSaveExternalPOError;
    default:
      return state;
  }
};

const bookingSaveExternalPOLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_SAVE_EXTERNAL_PO_LOADING:
      return action.bookingSaveExternalPOLoading;
    default:
      return state;
  }
};

const bookingSaveExternalPOSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_SAVE_EXTERNAL_PO_SUCCESS:
      return action.bookingSaveExternalPOSuccess;
    default:
      return state;
  }
};

// bookingUpdateBhpPOSuccess
const bookingUpdateBhpPOSave = (state = [], action) => {
  switch (action.type) {
    case BOOKING_UPDATE_BHP_PO_SUCCESS:
      return action.bookingUpdateBhpPO;
    default:
      return state;
  }
};

const bookingUpdateBhpPOError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPDATE_BHP_PO_ERROR:
      return action.bookingUpdateBhpPOError;
    default:
      return state;
  }
};

const bookingUpdateBhpPOLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPDATE_BHP_PO_LOADING:
      return action.bookingUpdateBhpPOLoading;
    default:
      return state;
  }
};

const bookingUpdateBhpPOSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_UPDATE_BHP_PO_SUCCESS:
      return action.bookingUpdateBhpPOSuccess;
    default:
      return state;
  }
};

const bookingHasDOViewError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_ERROR:
      return action.bookingHasDOViewError;
    default:
      return state;
  }
};

const bookingHasDOViewLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_LOADING:
      return action.bookingHasDOViewLoading;
    default:
      return state;
  }
};

const bookingHasDOViewSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_SUCCESS:
      return action.bookingHasDOViewSuccess;
    default:
      return state;
  }
};

const bookinghdo = (state = [], action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_VIEW_SUCCESS:
      return action.bookinghdo;
    default:
      return state;
  }
};

const bookingHasDOUpdateError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_ERROR:
      return action.bookingHasDOUpdateError;
    default:
      return state;
  }
};

const bookingHasDOUpdateInvalid = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_INVALID:
      return action.bookingHasDOUpdateInvalid;
    default:
      return state;
  }
};

const invalid = (state = [], action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_INVALID:
      return action.invalid;
    default:
      return state;
  }
};

const bookingHasDOUpdateLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_LOADING:
      return action.bookingHasDOUpdateLoading;
    default:
      return state;
  }
};

const bookingHasDOUpdateSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_HAS_DO_UPDATE_SUCCESS:
      return action.bookingHasDOUpdateSuccess;
    default:
      return state;
  }
};

const bookingListError = (state = false, action) => {
  switch (action.type) {
    case BOOKING_LIST_ERROR:
      return action.bookingListError;
    default:
      return state;
  }
};

const bookingListLoading = (state = false, action) => {
  switch (action.type) {
    case BOOKING_LIST_LOADING:
      return action.bookingListLoading;
    default:
      return state;
  }
};

const bookingListSuccess = (state = false, action) => {
  switch (action.type) {
    case BOOKING_LIST_SUCCESS:
      return action.bookingListSuccess;
    default:
      return state;
  }
};

const editStatusBookingLoading = (state = false, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_LOADING:
      return action.editStatusBookingLoading;
    default:
      return state;
  }
};

const editStatusBookingSuccess = (state = false, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_SUCCESS:
      return action.editStatusBookingSuccess;
    default:
      return state;
  }
};

const editStatusBookingData = (state = {}, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_SUCCESS:
      return action.editStatusBookingData;
    default:
      return state;
  }
};

const editStatusBookingError = (state = false, action) => {
  switch (action.type) {
    case EDIT_STATUS_BOOKING_ERROR:
      return action.editStatusBookingError;
    default:
      return state;
  }
};

// handle expire container
const handleExpiredContainerLoading = (state = false, action) => {
  switch (action.type) {
    case HANDLE_EXPIRED_CONTAINER_LOADING:
      return action.handleExpiredContainerLoading;
    default:
      return state;
  }
};

const handleExpiredContainerSuccess = (state = false, action) => {
  switch (action.type) {
    case HANDLE_EXPIRED_CONTAINER_SUCCESS:
      return action.handleExpiredContainerSuccess;
    default:
      return state;
  }
};

const handleExpiredContainerError = (state = false, action) => {
  switch (action.type) {
    case HANDLE_EXPIRED_CONTAINER_ERROR:
      return action.handleExpiredContainerError;
    default:
      return state;
  }
};

const bookingReducer = combineReducers({
  bookingGetRefund,
  bookingGetError,
  bookingGetLoading,
  bookingGetSuccess,
  bookings,

  bookingGetExcelError,
  bookingGetExcelLoading,
  bookingGetExcelSuccess,
  bookingExcel,

  bookingViewLoading,
  bookingViewError,
  bookingViewSuccess,
  booking,

  bookingViewLoadingOld,
  bookingViewErrorOld,
  bookingViewSuccessOld,
  bookingOld,

  bookingViewLoadingNew,
  bookingViewErrorNew,
  bookingViewSuccessNew,
  bookingNew,

  bookingAddError,
  bookingAddLoading,
  bookingAddSuccess,
  bookingAdded,

  bookingExternalPOUploadSuccess,
  bookingExternalPOUploadLoading,
  bookingExternalPOUploadError,
  bookingExternalPOUpload,

  bookingSaveExternalPOError,
  bookingSaveExternalPOSuccess,
  bookingSaveExternalPOLoading,
  bookingExternalPOSave,

  bookingPembayaranJPTUpload,
  bookingPembayaranJPTUploadError,
  bookingPembayaranJPTUploadLoading,
  bookingPembayaranJPTUploadSuccess,

  bookingRecipientGoodsUpload,
  bookingRecipientGoodsUploadError,
  bookingRecipientGoodsUploadLoading,
  bookingRecipientGoodsUploadSuccess,

  editPaymentUpload,
  editPaymentUploadError,
  editPaymentUploadLoading,
  editPaymentUploadSuccess,

  bookingUpdateBhpPOSuccess,
  bookingUpdateBhpPOError,
  bookingUpdateBhpPOLoading,
  bookingUpdateBhpPOSave,

  bookingHasDOViewError,
  bookingHasDOViewLoading,
  bookingHasDOViewSuccess,
  bookinghdo,

  bookingHasDOUpdateError,
  bookingHasDOUpdateLoading,
  bookingHasDOUpdateInvalid,
  invalid,
  bookingHasDOUpdateSuccess,

  bookingListError,
  bookingListLoading,
  bookingListSuccess,
  listPay,
  pay_chanel_generate,
  sisaKuotaKontainer,

  BookingPrev,
  BookingStatUpdate,

  editStatusBookingLoading,
  editStatusBookingSuccess,
  editStatusBookingData,
  editStatusBookingError,

  checkBookingStatus,
  checkBookingStatusLoading,
  checkBookingStatusSuccess,
  checkBookingStatusError,

  handleExpiredContainerError,
  handleExpiredContainerLoading,
  handleExpiredContainerSuccess,
});

export default bookingReducer;
